import React from 'react'

export default function DisplayNameInFooter(props) {
  const { selectedMovieOrPersonData, handleDelete, movieAlreadyAdded, selectedListType } = props
  return (
    <>
      {movieAlreadyAdded && <span style={{ color: 'red' }}>{selectedListType} already added</span>}
      {selectedMovieOrPersonData.map((item, index) =>
        item.label ? (
          <div
            key={index}
            className='d-flex  align-items-center'
            style={{
              border: '1px solid black',
              borderRadius: '5px',
              padding: '5px',
              margin: '5px',
            }}
          >
            {item.label ? item.label : item.name_En}
            <span
              style={{
                borderRadius: '50%',
                color: 'white',
                backgroundColor: '#474747',
                padding: '2px 5px',
                fontSize: '8px',
              }}
              onClick={() => handleDelete(index)}
            >
              X
            </span>
          </div>
        ) : (
          <></>
        ),
      )}
    </>
  )
}
